import { errorAlert } from "@app/utils/alerts";
import { getDataFile } from "@services/utils/formHelpers";
import { create } from "zustand";

type UsePrintTagType = {
  query: string;
  setQuery: (query: string) => void;
  fetchTag: (id: number, typeTag: string) => Promise<void>;
  loadingTag: boolean;
};

export const usePrintTag = create<UsePrintTagType>((set, get) => ({
  loadingTag: false,
  query: "",
  setQuery: (query) => set({ query }),
  fetchTag: async (id: number, typeTag: string) => {
    set({ loadingTag: true });
    try {
      const endpoint = `/reports/${typeTag}/${id}`;
      const response = await getDataFile(endpoint, { responseType: "blob" });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${typeTag}_${id}.pdf`);
      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      set({ loadingTag: false });
    } catch (error) {
      errorAlert("Error al descargar el archivo");
      set({ loadingTag: false });
    }
  },
}));
